import React from 'react';

/**
 * Dropdown de sugerencias de menciones (@usuario)
 */
const MentionSuggestions = ({
  show,
  users,
  onSelect,
}) => {
  if (!show || users.length === 0) return null;

  return (
    <div 
      className="absolute z-50 mt-1 w-full max-w-md bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto"
      data-testid="mention-suggestions"
    >
      {users.map((user) => (
        <div
          key={user.id}
          onClick={() => onSelect(user)}
          className="px-4 py-2 hover:bg-blue-50 cursor-pointer flex items-center gap-3 border-b last:border-b-0"
          data-testid={`mention-user-${user.id}`}
        >
          <div className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-semibold">
            {user.full_name?.charAt(0)?.toUpperCase() || user.email?.charAt(0)?.toUpperCase()}
          </div>
          <div className="flex-1">
            <p className="font-medium text-sm text-gray-900">{user.full_name}</p>
            <p className="text-xs text-gray-500">{user.email}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MentionSuggestions;
